// Bounds how many <video> elements may hold resources at once, app-wide.
// Product videos are raw/uncompressed (10-45 MB, often moov-at-end so the browser must pull most of the
// file before playing). A pause-only cap still left every scrolled-past video holding its buffer + decoder,
// so a long scroll through a video-heavy store (e.g. 19 videos, 320 MB) exhausted phone memory:
// black screen, hang, browser/app killed.
//   • at most `maxPlaying` are actually playing (older ones pause, keeping their last frame),
//   • at most `maxLoaded` keep a src at all (older ones are fully unloaded to free buffers + decoder).
export function createVideoSlots({ maxPlaying = 2, maxLoaded = 4 } = {}) {
  const loaded = []; // [{ el, unload }] oldest -> newest
  const apply = () => {
    while (loaded.length > maxLoaded) {
      const old = loaded.shift();
      old.el.pause?.();
      old.unload();
    }
    for (let i = 0; i < loaded.length - maxPlaying; i++) loaded[i].el.pause?.();
  };
  return {
    claim(el, unload) {
      const i = loaded.findIndex((x) => x.el === el);
      if (i !== -1) loaded.splice(i, 1);
      loaded.push({ el, unload });
      apply();
    },
    release(el) {
      const i = loaded.findIndex((x) => x.el === el);
      if (i !== -1) loaded.splice(i, 1);
    },
    stats: () => ({ loaded: loaded.length }),
  };
}
